module.exports = __webpack_public_path__ + "static/media/sell_take_order_teach_3.ec57237f.jpg";